export const id = {
  app: {
    name: "Aksaraku",
    tagline: "Belajar sambil bermain",
  },
  common: {
    on: "Nyala",
    off: "Mati",
    back: "Kembali",
    soon: "Segera hadir",
    loading: "Sebentar ya...",
  },
  nav: {
    parent: "Orang Tua",
    home: "Beranda",
  },
  profiles: {
    title: "Siapa yang mau main?",
    subtitle: "Pilih anak atau tambah profil baru",
    add: "Tambah Anak",
    namePlaceholder: "Nama anak",
    language: "Bahasa",
    start: "Mulai",
    empty: "Belum ada profil. Yuk tambah anak dulu.",
    errors: {
      emptyName: "Nama belum diisi",
      nameTooLong: "Nama terlalu panjang",
      invalidLocale: "Bahasa tidak dikenal",
    },
  },
  home: {
    greeting: "Halo, {{name}}!",
    tracing: "Menulis",
    games: "Permainan",
    rewards: "Koleksi",
    avatar: "Karakter",
  },
  play: {
    title: "Ayo Menulis",
    pick: "Pilih huruf, angka, atau bentuk",
    retry: "Coba Lagi",
    next: "Lanjut",
    great: "Hebat!",
    strokeProgress: "Garis {{current}} dari {{total}}",
    offTrack: "Ikuti garisnya ya",
    listen: "Dengar",
    canvasLabel: "Area menulis {{glyph}}",
    objectHint: "{{glyph}} untuk {{object}}",
    color: "Warnai",
  },
  games: {
    title: "Permainan",
    matching: "Cocokkan",
    balloon: "Pecahkan Balon",
    coloring: "Mewarnai",
    modeCase: "Besar - Kecil",
    modeObject: "Huruf - Gambar",
    casePrompt: "Cari huruf kecilnya",
    objectPrompt: "Huruf apa ini?",
    balloonPrompt: "Pecahkan balon: {{letter}}",
    repeat: "Ulangi",
    correct: "Benar!",
    wrong: "Coba lagi ya",
    playAgain: "Main Lagi",
    score: "{{correct}} dari {{total}} benar",
    colorHint: "Pilih warna, lalu sentuh hurufnya",
    stickers: "Stiker",
    clear: "Hapus",
    finish: "Selesai",
    finished: "Kerja bagus!",
    paint: "Warnai",
    painted: "{{painted}} dari {{total}} bagian diwarnai",
  },
  preview: {
    title: "Pratinjau Konten",
    hint: "Periksa bentuk semua huruf, angka, dan bentuk.",
  },
  rewards: {
    title: "Koleksi Hadiah",
    kind: {
      sticker: "Stiker",
      trophy: "Piala",
      character: "Karakter",
    },
    unlocked: "Kamu dapat hadiah baru!",
    yeay: "Yeay!",
    locked: "Terkunci",
    done: "Selesai",
    requirement: {
      itemsAttempted: "Coba {{count}} aktivitas",
      itemsMastered: "Kuasai {{count}} huruf atau angka",
      starsEarned: "Kumpulkan {{count}} bintang",
      totalAttempts: "Mainkan {{count}} kali",
      kindMastered: "Kuasai {{count}} di satu kategori",
    },
  },
  avatar: {
    title: "Karakterku",
    slot: {
      color: "Warna",
      ears: "Telinga",
      eyes: "Mata",
      accessory: "Aksesori",
    },
  },
  categories: {
    upper: "Huruf Besar",
    lower: "Huruf Kecil",
    digits: "Angka",
    shapes: "Bentuk",
  },
  mastery: {
    new: "Baru",
    learning: "Belajar",
    familiar: "Lancar",
    mastered: "Mahir",
  },
  parent: {
    title: "Area Orang Tua",
    gateTitle: "Khusus Orang Tua",
    gate: {
      question: "Berapa hasil dari {{a}} + {{b}}?",
      placeholder: "Jawaban",
      submit: "Masuk",
      wrong: "Jawaban belum tepat",
      cancel: "Batal",
    },
    progressFor: "Perkembangan {{name}}",
    progressQuick: "{{mastered}} dikuasai • {{attempted}} dicoba • ⭐ {{stars}}",
    report: "Laporan Perkembangan",
    summary: "Ringkasan",
    statMastered: "Dikuasai",
    statAttempted: "Dicoba",
    statStars: "Bintang",
    statAttempts: "Total Percobaan",
    levels: "Tingkat Penguasaan",
    byCategory: "Per Kategori",
    needsPractice: "Perlu Latihan",
    noWeak: "Semua yang dicoba sudah dikuasai. Hebat!",
    practiceDetail: "Akurasi {{score}}% • {{attempts}} kali",
    tracingQuality: "Kualitas Menulis",
    noTracing: "Belum ada latihan menulis.",
    avgAccuracy: "Rata-rata akurasi",
    traces: "Jumlah latihan",
    neverPlayed: "Belum ada aktivitas.",
    lastPlayed: "Terakhir bermain: {{date}}",
    screenTime: "Batas Waktu",
    sessionLimit: "Batas sesi",
    breakReminder: "Pengingat istirahat",
    breakOff: "Nonaktif",
    minutes: "{{minutes}} menit",
    sessionRemaining: "Sisa waktu sesi ini: {{time}}",
    settings: "Pengaturan",
    language: "Bahasa",
    haptics: "Getaran",
    audio: "Suara",
    reduceMotion: "Kurangi gerakan",
    switchProfile: "Ganti Anak",
    preview: "Pratinjau Konten",
    manageChildren: "Kelola Anak",
    activeChild: "Aktif",
    switchTo: "Pilih",
    delete: "Hapus",
    deleteConfirm: "Yakin hapus?",
    deleteHint: "Menghapus anak juga menghapus kemajuan dan koleksinya.",
    lastChildHint: "Minimal harus ada satu anak.",
    childLanguage: "Bahasa untuk {{name}}",
    cancel: "Batal",
  },
  session: {
    loading: "Sebentar ya…",
    expiredTitle: "Waktunya istirahat",
    expiredHint:
      "Sesi belajar hari ini sudah selesai. Minta Bunda atau Ayah membuka lagi ya.",
    parentUnlock: "Orang Tua",
    breakReminder: "Sudah {{minutes}} menit belajar. Istirahat dulu yuk!",
    breakDone: "Sudah istirahat",
  },
  settings: {
    errors: {
      invalidLocale: "Bahasa tidak valid",
      invalidSessionLimit: "Batas sesi tidak valid",
      invalidBreakReminder: "Pengingat istirahat tidak valid",
    },
  },
  error: {
    storage: "Gagal menyimpan data. Coba lagi ya.",
    retry: "Coba Lagi",
    reset: "Atur Ulang Data",
    resetHint: "Menghapus semua profil dan kemajuan di perangkat ini.",
    crash: "Ayah, ada yang-error. Coba lagi ya.",
    crashRetry: "Coba Lagi",
  },
  landing: {
    nav: {
      install: "Pasang Aplikasi",
      skip: "Lewati ke konten",
    },
    hero: {
      tagline: "Belajar sambil bermain",
      subtitle: "Aplikasi edukasi interaktif untuk balita 3+. Menulis, bermain, dan belajar — tanpa internet, tanpa iklan.",
      ctaInstall: "Pasang Sekarang",
      ctaHow: "Lihat cara kerjanya",
    },
    features: {
      title: "Apa yang ada di Aksaraku?",
      writing: { title: "Menulis", desc: "Trace huruf, angka, dan bentuk dengan panduan langkah demi langkah." },
      games: { title: "Permainan", desc: "Cocokkan, pecahkan balon, dan mewarnai sambil belajar." },
      rewards: { title: "Hadiah", desc: "Kumpulkan stiker, piala, dan karakter setiap berlatih." },
      parent: { title: "Dashboard Orang Tua", desc: "Pantau perkembangan, atur batas waktu, dan kelola profil anak." },
    },
    how: {
      title: "Cara Memulai",
      step1: { title: "Pasang", desc: "Tambahkan ke layar utama" },
      step2: { title: "Pilih Anak", desc: "Buat profil untuk si kecil" },
      step3: { title: "Mulai Belajar", desc: "Pilih huruf, angka, atau permainan" },
    },
    trust: {
      title: "Mengapa Aksaraku?",
      offline: "Berfungsi tanpa internet",
      noAds: "Tanpa iklan, tanpa gangguan",
      private: "Data tersimpan di perangkat",
      multiChild: "Profil untuk setiap anak",
    },
    languages: {
      title: "Tiga Bahasa",
      id: "Bahasa Indonesia",
      en: "English",
      ar: "العربية (RTL)",
    },
    footer: {
      cta: "Mulai Sekarang",
      madeBy: "Dibuat dengan ❤️ oleh Tim AI Engineering Rohmad",
    },
    install: {
      instructions: "Cara Memasang",
      ios: "Ketuk tombol Bagikan, lalu pilih \"Tambah ke Layar Utama\".",
      android: "Ketuk menu, lalu pilih \"Tambah ke layar utama\".",
      desktop: "Klik ikon pasang di address bar, atau gunakan menu browser.",
      openApp: "Buka Aplikasi",
    },
  },
} as const;
